import { Injectable } from "@angular/core";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { LayerUtilsService } from "./layer-utils.service";
import { SaveViewerlayer } from "../../model/SaveViewerlayer";
import { Viewerlayer } from "../../model/viewerlayer";
import { IProjectAOI } from "../../interfaces/i-project-aoi";
import { IUserInitialData } from "../../interfaces/i-user-initial-data";

@Injectable({
  providedIn: "root",
})
export class StatusService {
  static mapStatusData(
    mode: string,
    orientation: string,
    overlayLayers: Viewerlayer[] = null,
    filters: any = null,
    isActivatedBaseMap: boolean = false,
    centerAOI: IProjectAOI = null,
    infrared: boolean = false,
    measurementSystem: number = ViewerConstants.MEASUREMENT_SYSTEMS.IDS.METRIC,
  ): any {
    let layers = [];
    if (overlayLayers) {
      layers = layers.concat(LayerUtilsService.reduceLayers(overlayLayers));
    }

    const reduced = StatusService.reduceStateLayers(layers);

    return {
      mode,
      orientation,
      nir: infrared,
      layers: reduced,
      initialData: StatusService.getInitialData(centerAOI),
      filters,
      isActivatedBaseMap,
      measurementSystem,
    };
  }

  /**
   * Remove unused data to layers to save in state parameter
   * @param layers
   */
  static reduceStateLayers(layers: SaveViewerlayer[]): SaveViewerlayer[] {
    return layers?.map((layer) => {
      return {
        id: layer.id,
        layer: layer.layer,
        visible: layer.visible,
        enabledAois: layer.enabledAois,
      } as SaveViewerlayer;
    });
  }

  /**
   * Return the initial data object, it´s the same for the save configuration and the url state param
   * @param centerAOI
   */
  static getInitialData(centerAOI: IProjectAOI = null): IUserInitialData {
    return {
      aoi: centerAOI?.getName(),
      parentAoi: centerAOI?.getProject() || centerAOI?.getName(),
      layer: centerAOI?.getLayer(),
    };
  }
}
